module.exports = __webpack_public_path__ + "img/add_desktop_step2.6e6ed136.jpeg";